export const listPageCacheConstants = {
  SAVE_LIST_PAGE_CACHE: 'SAVE_LIST_PAGE_CACHE',
  CLEAR_LIST_PAGE_CACHE: 'CLEAR_LIST_PAGE_CACHE',
  CLEAR_ALL_LIST_PAGE_CACHE: 'CLEAR_ALL_LIST_PAGE_CACHE',
  RELOAD_LIST_PAGE_CACHE_CURRENT_PAGE: 'RELOAD_LIST_PAGE_CACHE_CURRENT_PAGE',
  UPDATE_LIST_PAGE_CACHE_ITEM: 'UPDATE_LIST_PAGE_CACHE_ITEM',
};
